import { ParamMap } from "@angular/router";

class RouterHelpersImpl
{
    /**
     * Attempts to retrieve the value for the requested `key` from the given `ParamMap` object.
     * If the `key` is not present, then the `fallback` value is returned.
     * @param params ParamMap object.
     * @param key Name of router or query parameter to get retrieved.
     * @param [fallback] Default value if key is not found.
     */
    tryGetParam(params: ParamMap, key: string, fallback: string = undefined): string
    {
        return params.has(key) ? params.get(key) : fallback;
    }

    /**
     * Attempts to retrieve the value for the requested `key` from the given `ParamMap` object.
     * If the `key` is not present, then the `fallback` value is returned.
     * @param params ParamMap object.
     * @param key Name of router or query parameter to get retrieved.
     * @param [fallback] Default value if key is not found.
     *
     * @returns boolean
     */
    tryGetBoolean(params: ParamMap, key: string, fallback: boolean = undefined): boolean
    {
        return params.has(key) ? /[Tt]rue/.test(params.get(key)) : fallback;
    }

    /**
     * Attempts to retrieve the value for the requested `key` from the given `ParamMap` object.
     * If the `key` is not present, then the `fallback` value is returned.
     * @param params ParamMap object.
     * @param key Name of router or query parameter to get retrieved.
     * @param [fallback] Default value if key is not found or the param doesn't have a valid date value.
     *
     * @return Date
     */
    tryGetDate(params: ParamMap, key: string, fallback: Date = undefined): Date
    {
        return params.has(key) && Date.parse(params.get(key)) ? new Date(params.get(key)) : fallback;
    }
}

export const RouterHelpers = new RouterHelpersImpl();
